import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './UserAuth.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Password tidak sama');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API_BASE}/users-auth/reset-password`, { token, new_password: password });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal reset password.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="user-auth-page">
        <div className="user-auth-box">
          <p className="user-auth-error">Link reset tidak valid. Minta link baru lewat halaman Lupa Password.</p>
          <p className="user-auth-footer"><Link to="/forgot-password">Ke Halaman Lupa Password</Link></p>
        </div>
      </div>
    );
  }

  return (
    <div className="user-auth-page">
      <div className="user-auth-box">
        <Link to="/" className="user-auth-logo">
          <img src="/logo.png" alt="Saskara Record" className="user-auth-logo-img" />
          SASKARA<span>RECORD</span>
        </Link>
        <p className="user-auth-subtitle">Buat Password Baru</p>

        {success ? (
          <div style={{ textAlign: 'center', color: '#9A9AA2', fontSize: 14 }}>
            <p>Password berhasil direset! Mengarahkan ke halaman login...</p>
          </div>
        ) : (
          <>
            {error && <div className="user-auth-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <input
                type="password"
                placeholder="Password Baru"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
              />
              <input
                type="password"
                placeholder="Konfirmasi Password Baru"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={6}
              />
              <button type="submit" disabled={loading}>
                {loading ? 'Menyimpan...' : 'Reset Password'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
